import {mapsBoundsScale} from "../tools/mapsBoundsScale";
import {Search} from "../Search";
import {formatQuick} from "../tools/formatQuick";
import {getLocationName} from "../structs/Filter";

function paddedBounds(map: google.maps.Map, top: number, right: number, bottom: number, left: number): google.maps.LatLngBounds {
    const bounds = map.getBounds();
    const pro = map.getProjection();
    const tr = pro.fromLatLngToPoint(bounds.getNorthEast());
    const bl = pro.fromLatLngToPoint(bounds.getSouthWest());
    const scale = Math.pow(2, map.getZoom());

    tr.y += top / scale;
    tr.x -= right / scale;
    bl.y -= bottom / scale;
    bl.x += left / scale;

    return new google.maps.LatLngBounds(pro.fromPointToLatLng(bl), pro.fromPointToLatLng(tr));
}

export class BoundHelper {
    readonly map: google.maps.Map;
    refPos: google.maps.LatLng;
    refZoom: number;
    liveSearch: boolean;
    private readonly _searchBounds: (bounds: google.maps.LatLngBounds) => void;
    private readonly _searchReset: () => void;
    private _areaButton: JQuery<HTMLElement> | null;
    private _backButton: JQuery<HTMLElement> | null;
    private _autoview = false;

    constructor(map: google.maps.Map, searchBounds: (bounds: google.maps.LatLngBounds) => void, searchReset: () => void) {
        this.map = map;
        this.liveSearch = false;
        this._searchBounds = searchBounds;
        this._searchReset = searchReset;
        this.map.addListener("idle", () => {
            if (this._autoview) {
                this.updateView();
                this._autoview = false;
            } else {
                if (this.liveSearch) {
                    this._searchBounds(this.reducedBounds());
                }
                this.manualUpdate();
            }
        });

        this.updateView();
    }

    reducedBounds(): google.maps.LatLngBounds {
        return paddedBounds(this.map, 100, 100, 80, 10);

        // new google.maps.Rectangle({
        //     map: this.map,
        //     bounds: bounds,
        //     fillOpacity: 0.15,
        //     strokeWeight: 0.9,
        //     clickable: false
        // });
    }

    updateView() {
        this._autoview = true;
        if (!this.liveSearch) {
            this.refPos = this.map.getCenter();
            this.refZoom = this.map.getZoom();
        }
    }

    private _displayAreaButton() {
        if (this._areaButton) return;
        const txt = Search.filterExt.txt["BereichDurchsuchen"];
        const style = "background:none padding-box #03d;color:#fff;border:0;margin:25px;padding:0 17px;appearance:none;user-select:none;overflow:hidden;height:40px;vertical-align:middle;font-family:Roboto,Arial,sans-serif;font-size:18px;box-shadow:rgba(0,0,0,0.3) 0 1px 4px -1px;font-weight:500;";
        this._areaButton = $('<div><button draggable="false" aria-label="' + txt + '" title="' + txt + '" type="button" role="menuitemradio" aria-checked="true" aria-haspopup="true" style="' + style + '">' + txt + '</button></div>');

        this._areaButton.on("click", () => {
            this.liveSearch = true;
            this._searchBounds(this.reducedBounds());
            this._removeButton();
            this.manualUpdate();
        })

        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(this._areaButton[0]);
    }

    private _displayBackButton() {
        if (this._backButton) return;

        const txt = formatQuick(Search.filterExt.txt["ZurueckZuP"], getLocationName(Search.filter));
        const style = "background:none padding-box #03d;color:#fff;border:0;margin:25px;padding:0 17px;appearance:none;user-select:none;overflow:hidden;height:40px;vertical-align:middle;font-family:Roboto,Arial,sans-serif;font-size:18px;box-shadow:rgba(0,0,0,0.3) 0 1px 4px -1px;font-weight:500;";
        this._backButton = $('<div><button draggable="false" aria-label="' + txt + '" title="' + txt + '" type="button" role="menuitemradio" aria-checked="true" aria-haspopup="true" style="' + style + '">' + txt + '</button></div>');

        this._backButton.on("click", () => {
            this.liveSearch = false;
            this._removeButton();
            this._searchReset();
        })

        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(this._backButton[0]);
    }

    private _removeButton() {
        if (!this._areaButton && !this._backButton) return;
        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
        this._areaButton = null;
        this._backButton = null;
    }

    manualUpdate() {
        if (this.liveSearch) {
            this._displayBackButton();
        } else {
            const outRef = this.map.getZoom() < this.refZoom || this.map.getZoom() > this.refZoom + 1 || !mapsBoundsScale(this.map.getBounds(), 0.5).contains(this.refPos);

            if (outRef) {
                this._displayAreaButton();
            } else {
                this._removeButton();
            }
        }
    }
}
